import {
  PRE_CALCULATIONS_HISTORY_GET_LIST_INIT,
  PRE_CALCULATIONS_HISTORY_GET_LIST_SUCCESS,
  PRE_CALCULATIONS_HISTORY_GET_LIST_FAILURE,
  PRE_CALCULATIONS_GET_DIMENSIONS_LIST_INIT,
  PRE_CALCULATIONS_GET_DIMENSIONS_LIST_SUCCESS,
  PRE_CALCULATIONS_GET_DIMENSIONS_LIST_FAILURE,
  PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_INIT,
  PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_SUCCESS,
  PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_FAILURE,
  PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT,
  PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS,
  PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE,
  PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_INIT,
  PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_SUCCESS,
  PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_FAILURE,
  PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_INIT,
  PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_SUCCESS,
  PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_FAILURE,
  PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_INIT,
  PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_SUCCESS,
  PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_FAILURE,
  PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_PREPARE_INIT,
  PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_INIT,
  PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_SUCCESS,
  PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_FAILURE,
  PRE_CALCULATIONS_HISTORY_RESET
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: PRE_CALCULATIONS_HISTORY_RESET
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PRE_CALCULATIONS_HISTORY_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationshistory/precalculationslist",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_GET_LIST_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: [],
    searches_are: [],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function getDimensionsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PRE_CALCULATIONS_GET_DIMENSIONS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_GET_DIMENSIONS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_GET_DIMENSIONS_LIST_FAILURE, error));
    }  
  };
}

export function getDimenesionInstancesSelect(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/getdimenesioninstances",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE, error));
    }  
  };
}

export function getPolynomialsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active", "sub_model"],
    searches_are: [true, true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_GET_POLYNOMIALS_LIST_FAILURE, error));
    }  
  };
}

export function exportCalculations(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationshistory/precalculationsexport",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_EXPORT_CALCULATIONS_FAILURE, error));
    }  
  };
}

export function getCalculationInstancesDetail(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationshistory/calculationinstancesdetail",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_GET_CALCULATION_INSTANCES_DETAIL_FAILURE, error));
    }  
  };
}

export function prepareDeleteCalculationInstance(id) {
  return {
    type: PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_PREPARE_INIT,
    id: id
  };
}

export function deleteCalculationInstance(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationshistory/deletecalculationinstance",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(PRE_CALCULATIONS_HISTORY_DELETE_CALCULATION_INSTANCE_FAILURE, error));
    }  
  };
}

export function resetImport() {
  return {
    type: PRE_CALCULATIONS_HISTORY_IMPORT_RESET
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/preCalculationsHistory/index.js